import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ContactCarrierService } from './contact-carrier.service';

@Component({
  selector: 'contact-carrier',
  template: require('./contact-carrier.component.html'),
  styles: [require('./contact-carrier.component.scss')],
  providers: [ContactCarrierService],
})
export class ContactCarrierComponent {

  @Input()
  set display(toDisplay: boolean) {
    this.service.show = toDisplay;
  }

  @Input()
  set schedule(item: any) {
    this.service.schedule = item;
    if (item != null) {
      this.service.getWebsite();
    }
  }

  @Output() onClose = new EventEmitter<boolean>();
  close() {
    this.onClose.emit(true);
  }

  constructor(private service: ContactCarrierService) {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/contact-carrier/contact-carrier.component.ts